
















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component
export default class Heading extends Vue {
  @Prop({ default: '' }) readonly header!: string
  @Prop({ default: '21' }) readonly headerSize!: string
  @Prop({ default: false }) readonly flipped!: boolean
  @Prop({ default: '' }) readonly icon!: string
  @Prop({ default: '' }) readonly subHeader!: string
  @Prop({ default: true }) readonly istop!: boolean

}
